module.exports = __webpack_public_path__ + "be9308df3f778cb287abf274b7012e2a.pdf";